import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { encrypt } from "../Utils/Encryption";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";

const BarCompare = ({ metricData }) => {
  const coordinates_data = JSON.parse(
    metricData?.comparison_coordinates || "{}"
  );

  const [chartData] = useState({
    series: [
      {
        name:
          coordinates_data?.visualization_data?.datasets?.[0]?.label ||
          "Metric 1",
        data: metricData?.value?.map((item) => Number(item?.metric_1)) || [],
      },
      {
        name:
          coordinates_data?.visualization_data?.datasets?.[1]?.label ||
          "Metric 2",
        data: metricData?.value?.map((item) => Number(item?.metric_2)) || [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      colors: ["#3a80c2", "#b1c74eff"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        title: {
          text: coordinates_data?.visualization_data?.xAxis || "X-Axis",
          style: {
            fontWeight: "",
            color: "#666",
            fontSize: "16px",
            fontFamily: "sans-serif",
          },
        },
        categories: metricData?.value?.map((item) => item?.name) || [],
      },
      yaxis: {
        title: {
          text: coordinates_data?.visualization_data?.yAxis || "Y-Axis",
          style: {
            fontWeight: "",
            color: "#666",
            fontSize: "16px",
            fontFamily: "sans-serif",
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}`,
        },
      },
    },
  });

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {metricData?.child && metricData?.pk_comparison_data_id ? (
          <Link
            to={`/dashboard/comparisonchildmetric/${
              metricData?.comparison_name
            }/${encrypt(metricData?.pk_comparison_data_id?.toString())}`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData?.comparison_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.comparison_name}</span>
          </div>
        )}
      </div>

      <div className="dashboardChart col-12">
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type="bar"
          width="100%"
          height={350}
          className="charts"
        />
      </div>
    </div>
  );
};

export default BarCompare;
